import React from 'react'
import PropTypes from 'prop-types'

const ForwardToInbox = ({ color, width, height, ...props }) => (
  <svg width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M18 0H2C0.9 0 0 0.9 0 2V14C0 15.1 0.9 16 2 16H11V14H2V4L10 9L18 4V9H20V2C20 0.9 19.1 0 18 0ZM10 7L2 2H18L10 7ZM17 11L21 15L17 19V16H13V14H17V11Z'
      fill={color}
    />
  </svg>
)

ForwardToInbox.defaultProps = {
  color: 'currentColor',
  width: '24',
  height: '24',
}

ForwardToInbox.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
}

export default ForwardToInbox
